
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useState } from "react";
import { toast } from "sonner";

interface SubscribeProps {
  className?: string;
}

const Subscribe = ({ className = "" }: SubscribeProps) => {
  const [email, setEmail] = useState("");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (email) {
      toast.success("Thank you for subscribing!");
      setEmail("");
    }
  };

  return (
    <form onSubmit={handleSubmit} className={`w-full max-w-md ${className}`}>
      <div className="flex flex-col sm:flex-row gap-3">
        <Input
          type="email"
          placeholder="Enter your email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="flex-grow min-w-0 text-foreground dark:text-white"
          required
        />
        <Button 
          type="submit" 
          className="bg-purple-600 hover:bg-purple-700 text-white transition-colors duration-200"
        >
          Subscribe
        </Button>
      </div>
    </form>
  );
};

export default Subscribe;
